const checkDate = (data) => {
  return new Date(data) instanceof Date && !isNaN(new Date(data));
};

export default checkDate;
